// extracted by mini-css-extract-plugin
export default {"branding":"_16D6rT-xjn","branding-icon":"_90Jprd2uyT","brandingIcon":"_90Jprd2uyT","branding-cluster":"NvNqHoBRAk","brandingCluster":"NvNqHoBRAk","branding-text":"jki4aDDCQA","brandingText":"jki4aDDCQA"};
    if(module.hot) {
      // 1648554095156
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  